export default "__VITE_ASSET__9df7cfac__"